var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"dataTable",attrs:{"columns":_vm.groupMapCols,"rows":_vm.groups,"selection":""},on:{"selection-change":_vm.handleSelectionChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }